module.exports = __webpack_public_path__ + "img/brajesh.2b058144.png";